export default "/assets/images/app-screen4.8604a38fa77c37d3.jpg";